import createTaskPaneRunningInstance from '../store/createTaskPaneRunningInstance';
import getExtensibilityState from '../store/getExtensibilityState';
import IAddinCommand from '../store/schema/interfaces/IAddinCommand';
import TaskPaneType from '../store/schema/TaskPaneType';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setTaskPaneAddinCommand', function setTaskPaneAddinCommand(
    controlId: string,
    hostItemIndex: string,
    addinCommand: IAddinCommand,
    type: TaskPaneType,
    mode: ExtensibilityModeEnum,
    initializationContext?: string
) {
    const { taskPanes } = getExtensibilityState();

    const newTaskPane = createTaskPaneRunningInstance(
        controlId,
        addinCommand,
        hostItemIndex,
        mode,
        null /* errorType */,
        initializationContext
    );
    taskPanes.set(type, newTaskPane);
});
